import React, { Component } from 'react';
import Banner from './Banner'
import Form from './Form/Form'
class Login extends Component {

    render() { 
        let { disabledBtn , loginError , submitForm  , handleSubmit , handleChangePassword , handleChangeUsername , 
        username , password,hideMessage } = this.props
        return ( 
            <div className="grid lg:grid-cols-2">
                <div className="cols-span-1">
                    <Banner />
                </div>
                <div className="cols-span-1">
                    <Form
                     disabledBtn = {disabledBtn}
                     loginError = {loginError}
                     submitForm ={submitForm}
                     handleSubmit = {handleSubmit}
                     handleChangeUsername = {handleChangeUsername}
                     handleChangePassword = {handleChangePassword}
                     username={username}
                     password={password}
                     hideMessage={hideMessage}

                     />

                </div>

            </div>
         );
    }
}
 
export default Login;
